import React from "react";

// Creating custom hook with context
const CreateHook = (name, context) => {
  const reactContext = React.useContext(context);
  if (!reactContext) {
    throw new Error(
      `${name} hook must be used within a ContextProvider component`
    );
  }
  return reactContext;
};

const shouldSendAnalytics = () => {
  const isLocalhost = () => {
    return (
      window.location.hostname === "localhost" ||
      window.location.hostname === "127.0.0.1" ||
      window.location.hostname ===
        "dev-7233-add-spot-to-feel-performer.d3b7w7wvinzi8a.amplifyapp.com"
    );
  };
  return process.env.NODE_ENV === "production" && !isLocalhost();
};

// ----- converting values to bytes -----
const convertPercentToCommandValue = (percent) => {
  return Math.max(1, Math.round((percent / 100) * 255));
};

const convertValueToUint16 = (value) => {
  const lowByte = value & 0xff;
  const highByte = (value >> 8) & 0xff;
  return [highByte, lowByte];
};

const rgbStringToArray = (rgbString) => {
  // colors for LED has to be written in the following order: GREEN, BLUE, RED
  const rgbArray = rgbString.match(/\d+/g).map((value) => parseInt(value, 10));
  const firstElement = rgbArray.shift();
  rgbArray.push(firstElement);
  return [rgbArray[0], rgbArray[2], rgbArray[1]];
};

const mapHexColorsToNames = (hexColor) => {
  switch (hexColor.toUpperCase()) {
    case "#4D4D4D":
      return "Gray";
    case "#999999":
      return "Steel Gray";
    case "#FFFFFF":
      return "White";
    case "#F44E3B":
      return "Red Orange";
    case "#FE9200":
      return "Orange";
    case "#FCDC00":
      return "Yellow";
    case "#DBDF00":
      return "Lime";
    case "#A4DD00":
      return "Green Yellow";
    case "#68CCCA":
      return "Teal";
    case "#73D8FF":
      return "Sky Blue";
    case "#AEA1FF":
      return "Lavender Blue";
    case "#FDA1FF":
      return "Light Lavender";
    case "#333333":
      return "Charcoal";
    case "#808080":
      return "Gray";
    case "#CCCCCC":
      return "Light Gray";
    case "#D33115":
      return "Red";
    case "#E27300":
      return "Rust";
    case "#FCC400":
      return "Amber";
    case "#B0BC00":
      return "Olive";
    case "#68BC00":
      return "Green";
    case "#16A5A5":
      return "Turquoise";
    case "#009CE0":
      return "Azure";
    case "#7B64FF":
      return "Blue Violet";
    case "#FA28FF":
      return "Pink Purple";
    case "#000000":
      return "No Color";
    case "#666666":
      return "Dim Gray";
    case "#B3B3B3":
      return "Silver";
    case "#9F0500":
      return "Dark Red";
    case "#C45100":
      return "Burnt Orange";
    case "#FB9E00":
      return "Bright Orange";
    case "#808900":
      return "Olive Drab";
    case "#194D33":
      return "Forest Green";
    case "#0C797D":
      return "Viridian";
    case "#0062B1":
      return "Cerulean";
    case "#653294":
      return "Purple Heart";
    case "#AB149E":
      return "Purple Rouge";
    default:
      return hexColor.toUpperCase();
  }
};

const hexToRgb = (hex) => {
  if (!hex) {
    return;
  }
  // Remove the hash if present
  hex = hex.replace(/^#/, "");

  // Parse the hex values to RGB
  const bigint = parseInt(hex, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;

  return `rgb(${r},${g},${b})`;
};

const findMaxRGBValue = (rgbArray) => {
  let max = 0;
  // Loop through each RGB string in the array
  rgbArray.forEach((rgbString) => {
    // Extract the values of red, green, and blue from the RGB string
    const matches = rgbString.match(/rgb\((\d+),(\d+),(\d+)\)/);

    if (matches) {
      // Convert the extracted values to numbers
      const [_, red, green, blue] = matches.map(Number);
      // Update the max value if any of x, y, or z is greater
      max = Math.max(max, red, green, blue);
    }
  });

  return max;
};

export {
  CreateHook,
  shouldSendAnalytics,
  convertPercentToCommandValue,
  convertValueToUint16,
  rgbStringToArray,
  mapHexColorsToNames,
  hexToRgb,
  findMaxRGBValue,
};
